<template>
  <Pagination
    :table-collection="clientLogCollection"
    :detailed="true"
    sorting-field="timestamp"
    range-field="timestamp"
  >
    <template slot-scope="props" @openRemoveModal="openRemoveModal">
      <b-table-column :label="$t('severity')">
        <b-tooltip
          position="is-left"
          :class="
            props.row.type === 'log'
              ? 'is-info'
              : props.row.type === 'warning'
              ? 'is-warning'
              : props.row.type === 'error'
              ? 'is-danger'
              : ''
          "
          :label="
            props.row.type === 'log'
              ? $t('logLevel1')
              : props.row.type === 'warning'
              ? $t('logLevel2')
              : props.row.type === 'error'
              ? $t('logLevel3')
              : ''
          "
        >
          <b-icon
            :icon="
              props.row.type === 'log'
                ? 'flag'
                : props.row.type === 'warning'
                ? 'alert'
                : props.row.type === 'error'
                ? 'alert-octagon'
                : ''
            "
            :type="
              props.row.type === 'log'
                ? 'is-info'
                : props.row.type === 'warning'
                ? 'is-warning'
                : props.row.type === 'error'
                ? 'is-danger'
                : ''
            "
          />
        </b-tooltip>
      </b-table-column>
      <b-table-column :label="$t('eventId')">
        {{ props.row.eventId }}
      </b-table-column>
      <b-table-column :label="$t('msg')">
        {{ props.row.msg }}
      </b-table-column>
      <b-table-column :label="$t('error')">
        {{ props.row.error }}
      </b-table-column>
      <b-table-column :label="$t('actions')" centered>
        <b-button type="is-small is-danger ml-2" icon-right="delete" @click="deleteError(props.row.id)" />
      </b-table-column>
      <b-table-column :label="$t('timestamp')" centered>
        <span class="tag is-primary">
          {{
            props.row.timestamp.toDate().toLocaleTimeString() + ", " + props.row.timestamp.toDate().toLocaleDateString()
          }}
        </span>
      </b-table-column>
    </template>
    <template slot="detail" slot-scope="props">
      <ul>
        <li v-for="(value, key) in props.row.metadata" :key="key">
          <b>{{ key }}</b
          >: {{ value }}
        </li>
      </ul>
    </template>
  </Pagination>
</template>

<script>
import Pagination from "@/components/Pagination";

export default {
  name: "ClientLogsTable",
  components: {
    Pagination,
  },
  props: {
    clientLogCollection: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    async deleteError(logId) {
      try {
        await this.clientLogCollection.doc(logId).delete();
        this.$buefy.toast.open(this.$t("logDeleted"));
      } catch (err) {
        this.$buefy.toast.open(err.toString());
      }
    },
  },
};
</script>
